var exports = {
  "kL": "x4ddf2309--db5825--container",
  "DD": "x4ddf2309--db5825--title",
  "Xu": "x4ddf2309--db5825--distance-input",
  "r7": "x4ddf2309--db5825--black-friday-filter",
  "Y4": "x4ddf2309--db5825--black-friday-icon",
};

module.exports = exports;
